module.exports = __webpack_public_path__ + "static/venezia-ramirez-59d233369213506daf57a534995a0a4f.jpg";